export function isTruthyVoiceFlag(value: unknown): boolean {
  if (typeof value === "boolean") return value;
  if (typeof value === "number") return value === 1;
  if (typeof value === "string") {
    const normalized = value.trim().toLowerCase();
    return normalized === "true" || normalized === "1" || normalized === "yes";
  }
  return false;
}

export function hasAllChannelAccess(channelType: unknown): boolean {
  if (Array.isArray(channelType)) {
    return channelType.some((value) => hasAllChannelAccess(value));
  }

  if (typeof channelType !== "string") return false;

  return channelType
    .split(",")
    .map((value) => value.trim().toLowerCase())
    .includes("all");
}

export function isModelVoiceEnabled(modelConfig?: Record<string, any> | null): boolean {
  if (!modelConfig) return false;

  return (
    isTruthyVoiceFlag(modelConfig.Is_Enabled) &&
    hasAllChannelAccess(modelConfig.ChannelType) &&
    isTruthyVoiceFlag(
      modelConfig.is_Voice_Enabled ?? modelConfig.Is_Voice_Enabled
    )
  );
}
